"use client";
import Image from "next/image";
import Link from "next/link";
import React, { useEffect, useRef } from "react";
import { BsFillArrowRightCircleFill } from "react-icons/bs";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

import AboutImage from "../../../public/assets/bottel-manuf.png";
import Experiance from "../../../public/assets/year-exp.png";

gsap.registerPlugin(ScrollTrigger);

const SecAbout = () => {
  const sectionRef = useRef(null);

  useEffect(() => {
    const ctx = gsap.context(() => {
      // Animate Heading Words
      gsap.fromTo(
        ".split-word",
        { y: 60, opacity: 0, rotateX: 30 },
        {
          y: 0,
          opacity: 1,
          rotateX: 0,
          duration: 1,
          stagger: 0.2,
          ease: "power3.out",
          scrollTrigger: {
            trigger: ".split-word",
            start: "top 85%",
            toggleActions: "play none none reset",
          },
        }
      );

      // Animate Paragraphs
      gsap.fromTo(
        ".fade-para",
        { y: 40, opacity: 0 },
        {
          y: 0,
          opacity: 1,
          duration: 1.2,
          ease: "power2.out",
          stagger: 0.25,
          scrollTrigger: {
            trigger: ".fade-para",
            start: "top 90%",
            toggleActions: "play none none reset",
          },
        }
      );

      // Animate Button
      gsap.fromTo(
        ".fade-button",
        { scale: 0.8, opacity: 0 },
        {
          scale: 1,
          opacity: 1,
          duration: 0.8,
          delay: 0.3,
          ease: "back.out(1.7)",
          scrollTrigger: {
            trigger: ".fade-button",
            start: "top 95%",
            toggleActions: "play none none reset",
          },
        }
      );
    }, sectionRef);

    return () => ctx.revert(); // Cleanup on unmount
  }, []);

  return (
    <section className="xl:py-[100px] py-[50px] px-[20px] xl:px-0" ref={sectionRef}>
      <div className="container mx-auto">
        <div className="grid xl:grid-cols-2 gap-2">
          {/* Left Side */}
          <div>
            <h2 className="text-4xl font-bold mb-2 text-left text-[#282930]">
              <span className="split-word inline-block mr-2">About</span>
              <span className="split-word inline-block red-gradient-text">
                Us
              </span>
            </h2>

            <h4 className="text-left font-semibold text-base fade-para">
              Since inception of Emerge Glass in 2013
            </h4>

            <p className="text-left text-sm mt-5 text-[#666] mb-2 leading-7 fade-para">
              We earnestly ensured to manufacture the highest standards of glass
              solutions and constantly strived to match industry practices.
            </p>

            <p className="text-sm text-[#666] leading-7 fade-para">
              Emerge Glass produces the finest quality glass ranging from
              1mm~10mm and is acclaimed to be the leading manufacturer of Thin
              Flat glass in India. We are the only manufacturer in India to
              produce 1mm thin flat glass. These Thin Flat Glasses of varied
              thicknesses are used in photo frames, micro-slides, wall clocks,
              household windows and many other multipurpose usages.
            </p>

            <Link
              href=""
              className="fade-button border-b-2 border border-red-600 bg-transparent inline-flex items-center gap-2 px-3 py-1 mt-5 rounded-full text-sm transition ease-in-out duration-300 hover:duration-500 hover:bg-red-600 hover:text-white group"
            >
              <BsFillArrowRightCircleFill className="text-red-600 group-hover:text-white transition ease-in-out duration-300 hover:duration-500" />
              <span>Read More</span>
            </Link>
          </div>

          {/* Right Side Image */}
          <div className="flex justify-end xl:mt-0 mt-5">
            <div className="relative before:absolute before:top-0 before:left-0 before:w-full before:h-full before:bg-gradient-to-br before:rounded-lg before:from-black before:to-transparent">
              <Image
                src={AboutImage}
                alt="About Us"
                loading="lazy"
                className="rounded-lg"
              />
              <Image
                src={Experiance}
                alt="Experience"
                loading="lazy"
                className="w-[130px] rounded-se-4xl absolute -bottom-1 rounded-es-lg"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default SecAbout;
